module.exports = __webpack_public_path__ + "img/content.4f073333.png";